module.exports = __webpack_public_path__ + "static/react_audio_element-cf956f5cd62bd34411d6692aec4c28e7.png";